import { aiPlanningPlanEntrypoint } from '@jira/spa-apps__ai-planning/src/aiPlanningPlanEntrypoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { softwareAiPlanningClassicPlanRoute } from '@jira/router-routes__software-ai-planning-routes/src/softwareAiPlanningClassicPlanRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';

const aiPlanningClassicSoftwarePlanPageEntrypoint = createChromelessEntryPoint({
	main: aiPlanningPlanEntrypoint,
});

export const softwareAiPlanningClassicPlanRouteEntry: Route = createEntry(
	softwareAiPlanningClassicPlanRoute,
	() => ({
		group: 'classic-software',
		ufoName: 'software-ai-planning-classic-plan',
		layout: { isChromeless: true, globalComponents: [], rightSidebars: [] },
		resources: [],

		meta: {
			reporting: {
				id: 'software-ai-planning-classic-plan',
				packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
				teamName: 'Reverie',
			},
		},

		entryPoint: () =>
			fg('jira_ai_planner_tab')
				? aiPlanningClassicSoftwarePlanPageEntrypoint
				: notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
